<template>
  <div class="plain row justify-content-center align-items-center">
    <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.plain
  background-image url('../assets/images/background.jpg')
  background-repeat no-repeat
  background-attachment fixed
  background-size cover
  background-position center
  width 100vw
  height 100vh

</style>
